var map = {
	"./1.png": 784,
	"./2.png": 763,
	"./3.png": 930,
	"./4.png": 989,
	"./5.png": 364,
	"./6.png": 399,
	"./Amazon_Web_Services_Logo.svg 1.png": 452,
	"./Angular_Logo_SVG.svg 1.png": 499,
	"./Ansible_logo.svg 1.png": 38,
	"./Django_logo.svg 1.png": 865,
	"./Docker_logo 1.png": 254,
	"./Flask_logo.svg 1.png": 357,
	"./Go_Logo_Blue.svg 1.png": 475,
	"./Google_Cloud_logo.svg 1.png": 167,
	"./Group 75.png": 526,
	"./Java_programming_language_logo.svg 1.png": 23,
	"./Jenkins_logo_with_title.svg 1.png": 540,
	"./Kubernetes_logo_without_workmark.svg 1.png": 614,
	"./Logo-redis.svg 1.png": 251,
	"./Microsoft_Azure.svg 1.png": 368,
	"./Mongodb-ar21.svg 1.png": 497,
	"./MySQL_textlogo.svg 1.png": 569,
	"./Node.js_logo_2015.svg 1.png": 582,
	"./PHP-logo.svg 1.png": 352,
	"./Postgresql_elephant.svg 1.png": 726,
	"./Python-logo-notext.svg 1.png": 631,
	"./React-icon.svg 1.png": 297,
	"./Ruby_logo.svg 1.png": 498,
	"./Spring_Boot.svg 1.png": 978,
	"./Terraform_Logo.svg 1.png": 250,
	"./Unofficial_JavaScript_logo_2.svg 1.png": 545,
	"./Valkey_logo.svg 1.png": 868,
	"./Vue.js_Logo_2.svg 1.png": 980
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 684;